module.exports = {
          srcSet: __webpack_public_path__ + "public/599c9062d18a9be7ec52313a09e08578-51.png"+" 51w",
          images:[ {path: __webpack_public_path__ + "public/599c9062d18a9be7ec52313a09e08578-51.png",width: 51,height: 53}],
          src: __webpack_public_path__ + "public/599c9062d18a9be7ec52313a09e08578-51.png",
          toString:function(){return __webpack_public_path__ + "public/599c9062d18a9be7ec52313a09e08578-51.png"},
          
          width: 51,
          height: 53
        }